<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false" :width="630">
    <div slot="header" class="modal-header">跟进</div>
    <Form :model="formData" :label-width="0"  :rules="formRules" ref="formData">
      <FormItem prop="remark">
        <Input type="textarea"
               :rows="4"  :maxlength="150"
               placeholder="请录入跟进内容，不超过150字"
               v-model="formData.remark"

        ></Input>
      </FormItem>
      <FormItem>
        <div style="display: flex;flex-wrap: wrap">
          <template v-for="item in data " v-if="data">
            <div class="fileItem">
              <div style="margin-bottom: 10px;">
                <img class="file-img" :src="item.url" alt="">
                <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem(item)">删除</a>
              </div>
            </div>
          </template>
          <div class="fileItem" v-if="data.length<=3">
            <Upload class="upload"
                    :action="baseUrl+'/file/uploadFile'"
                    :on-success="handleSuccess"
                    :headers="{'Access-Token':token}"
                    :show-upload-list="false"
                    :on-error="handleError"
                    :format="['jpg','jpeg','png']"
                    :on-format-error="formatError"
            >
              <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
            </Upload>

          </div>
        </div>
      </FormItem>
    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >确定</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
import { saveReceiveFollow } from 'api/accountsReceivable'
import {getBaseUrl} from "../../../../utils/public";
import {getToken} from "../../../../utils/auth";

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    billId:{
      type:Number,
      default:null
    },
    contractCode:{
      type:String,
      default:''
    }
  },
  watch:{
    n(val) {
      this.show = true
      this.$refs['formData'].resetFields()
      this.baseUrl = getBaseUrl()
      this.token = getToken()
      this.data=[]
    }
  },
  data() {
    return {
      data: [],
      token: '',
      baseUrl: '',
      loading:false,
      show: false,
      formData:{
        remark:''
      },
      formRules:{
        remark:[{ required: true, message:'请录入跟进内容', trigger: "blur" }]
      }
    }
  },
  methods:{
    close(){
      this.show = false
    },
    save() {
       // 调接口
       this.$refs[`formData`].validate(bool => {
         if(bool) {
           let imgList = []
           this.data.forEach((ele, index) => {
             imgList.push(ele.url)
           })
           if(imgList.length > 4){
             this.$Message.info('最多上传4张图片')
             return
           }
           let data = {
             contractCode:this.contractCode,
             billId:this.billId,
             uploadfile:imgList,
             urgeDesc:this.formData.remark
           }
           this.loading = true
           saveReceiveFollow(data).then(res => {
             this.loading = false
              this.$Message.success('操作成功！')
              this.show = false
              this.$emit('refresh')
            }).catch( err => {
              this.loading = false
            })

         }
       })
    },
    formatError(){
      this.$Message.info('请上传图片类型文件')
    },
    handleError() {

    },
    handleSuccess(res) {
      this.data.push(res.data)
    },
    deleteItem(img) {
      this.data = this.data.filter( item => {
        return item.fid != img.fid
      })
    }
  }
}
</script>

<style scoped>

  .upload {
    display: inline-block;
    width: 150px;
    height: 85px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }

  .fileItem {
    margin-right: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;

  }

  .file-img {
    width: 150px;
    height: 85px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }
</style>
